module.exports = __webpack_public_path__ + "img/2recr_province.d35293d9.png";